import { Table, Text } from '@radix-ui/themes'
import type { TRPCOutputs } from '~/utils/trpc'
import { CellText } from '~/components/CellText'
import { TabState } from '~/components/TabState'

type Contact = TRPCOutputs['ops']['contacts']['list'][number]

interface OrgContactsTabProps {
  contacts: Contact[]
  loading: boolean
  error: string | null
}

export const OrgContactsTab = ({ contacts, loading, error }: OrgContactsTabProps) => (
  <TabState
    loading={loading}
    error={error}
    isEmpty={contacts.length === 0}
    emptyMessage="No contacts for this organization."
  >
    <Table.Root variant="surface">
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeaderCell>Name</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Email</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Phone</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Address</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Installations</Table.ColumnHeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {contacts.map((contact) => (
          <Table.Row key={contact.id}>
            <Table.Cell>
              <Text size="2" weight="medium">
                {contact.name}
              </Text>
            </Table.Cell>
            <Table.Cell>
              <CellText value={contact.email} />
            </Table.Cell>
            <Table.Cell>
              <CellText value={contact.phone} />
            </Table.Cell>
            <Table.Cell>
              <CellText value={contact.address} />
            </Table.Cell>
            <Table.Cell>
              <Text size="2">{contact.installationCount}</Text>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  </TabState>
)
